import PlainTextCell from 'components/PlainTextCell';

import { parseDate } from 'utils/dates';

interface CellProps {
  rowData: {
    createdAt?: string | null;
    scheduledForDeletionAt?: string | null;
  };
  /** Date and time on one line ("28 Aug 2025 9:02 PM") instead of two. */
  singleLine?: boolean;
}

export default function CreatedAtCell({
  rowData: { createdAt, scheduledForDeletionAt },
  singleLine = false,
}: CellProps) {
  if (!createdAt) {
    return <PlainTextCell topLine={undefined} />;
  }

  const [date, time] = parseDate(createdAt);
  const topLine = singleLine ? `${date} ${time}` : date;
  const bottomLine = singleLine ? undefined : time;

  return (
    <PlainTextCell
      color={scheduledForDeletionAt ? 'alaskanHusky' : undefined}
      {...{ topLine, bottomLine }}
    />
  );
}
